export default [
  {
    title: 'Save the Children',
    url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
    img: {
      normal: new URL('../../images/support-img/11.png', import.meta.url).href,
      retina: new URL('../../images/support-img/12.png', import.meta.url).href,
    },
  },
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img: {
      normal: new URL('../../images/support-img/21.png', import.meta.url).href,
      retina: new URL('../../images/support-img/22.png', import.meta.url).href,
    },
  },
  {
    title: 'UNITED24',
    url: 'https://u24.gov.ua/uk',
    img: {
      normal: new URL('../../images/support-img/31.png', import.meta.url).href,
      retina: new URL('../../images/support-img/32.png', import.meta.url).href,
    },
  },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
    img: {
      normal: new URL('../../images/support-img/41.png', import.meta.url).href,
      retina: new URL('../../images/support-img/42.png', import.meta.url).href,
    },
  },
  {
    title: 'Medicins Sans Frontieres',
    url: 'https://www.msf.org/ukraine',
    img: {
      normal: new URL('../../images/support-img/51.png', import.meta.url).href,
      retina: new URL('../../images/support-img/52.png', import.meta.url).href,
    },
  },
  {
    title: 'RAZOM',
    url: 'https://www.razomforukraine.org/',
    img: {
      normal: new URL('../../images/support-img/61.png', import.meta.url).href,
      retina: new URL('../../images/support-img/62.png', import.meta.url).href,
    },
  },
  {
    title: 'Action against hunger',
    url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
    img: {
      normal: new URL('../../images/support-img/71.png', import.meta.url).href,
      retina: new URL('../../images/support-img/72.png', import.meta.url).href,
    },
  },
  {
    title: 'World vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
    img: {
      normal: new URL('../../images/support-img/81.png', import.meta.url).href,
      retina: new URL('../../images/support-img/82.png', import.meta.url).href,
    },
  },
  {
    title: 'Serhiy Prytula Charity Foundation',
    url: 'https://prytulafoundation.org/en',
    img: {
      normal: new URL('../../images/support-img/91.png', import.meta.url).href,
      retina: new URL('../../images/support-img/92.png', import.meta.url).href,
    },
  },
];
